import { useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import {useAuth} from '../context/auth'
import axios from 'axios';

export default function useTokenVerifier(hasError, message) {
  const [auth, setAuth] = useAuth()
  const history = useHistory()

  useEffect(() => {
      if (hasError && ['InvalidJWT', 'MissingJWT', 'InvalidUser'].includes(message)) {
          setAuth({})
          history.push('/login')
      } else if (hasError && ['TokenExpired'].includes(message)) {
        refreshToken(process.env.REACT_APP_API_BASE_URL, auth)
      }
  }, [hasError, message, setAuth, auth, history])
}

export async function refreshToken(host, auth) {
  try {
    const response = await axios.post(`${host}/auth/refresh-token`, {
      refreshToken: auth.refreshToken,
    }, {
      headers: {
        'Content-Type': 'application/json',
        "response-type": "json",
        "X-Trato-Source": "plugin"
      },
    })
    const payload = response.data;

    if (payload.success) {
      localStorage.setItem('auth', JSON.stringify({
        ...auth,
        expiresIn: payload.data.expiresIn,
        expiresAt: Date.now() + (Number(payload.data.expiresIn) * 1000),
        accessToken: payload.data.accessToken,
        idToken: payload.data.idToken
      }))
    } else {
      localStorage.setItem('auth', JSON.stringify({}))
    }
     
  } catch (error) {
    localStorage.setItem('auth', JSON.stringify({}))
  }

}